import { useEffect, useState } from 'react';
import { fetchPricing } from '../services/api';
import { logger } from '../utils/logger';

export const usePricingData = () => {
  const [tariffs, setTariffs] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    fetchPricing()
      .then((data) => {
        if (!isMounted) return;
        setTariffs(Array.isArray(data) ? data : []);
        setError(null);
      })
      .catch((err) => {
        if (!isMounted) return;
        logger.error('❌ Pricing: ошибка при получении тарифов', err);
        setError('Не удалось загрузить тарифы');
        setTariffs([]);
      })
      .finally(() => {
        if (!isMounted) return;
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return {
    tariffs,
    error,
    isLoading,
  };
};
